<template>
  <div class="modal-list" data-simplebar>
    <!-- Results List -->
    <div class="results-list-v2"
      v-if="responseData.length > 0 || replaceItemAnalogs != undefined || replaceItem != undefined">
      <!-- Replace Item (if exists) -->
      <div v-if="replaceItem != undefined && replaceItemAnalogs == undefined" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + replaceItem.image" :alt="replaceItem.full_name" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="replaceItem.on_order" class="order-badge-v2">Під замовлення</div>
            <h4 class="result-title-v2">{{ replaceItem.full_name }}</h4>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ replaceItem.code }}</span>
              <span class="result-status-v2" :class="replaceItem.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="replaceItem.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ replaceItem.quantity == 0 ? 'Термін постачання до: ' +
                  replaceItem.terms : 'В наявності' }}
              </span>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="replaceItem.price > 0" class="price-info-v2">
            <span class="price-value-v2">
              {{ what == 'materials' ? (+replaceItem.p).toFixed(2) : replaceItem.price }}
            </span>
            <span class="price-currency-v2">{{ replaceItem.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? replaceItem.base_unit_name : replaceItem.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <div class="select-actions-v2">
            <span class="replace-badge">
              <i class="fa fa-exchange-alt"></i>
              Заміна
            </span>
          </div>
        </div>
      </div>

      <!-- Separator between replace item and search results -->
      <div v-if="(replaceItem != undefined || replaceItemAnalogs != undefined) && responseData.length > 0"
        class="replace-separator">
        <div class="replace-separator-line"></div>
        <div class="replace-separator-text">
          <i class="fa fa-exchange-alt"></i>
          <span>Оберіть заміну з результатів пошуку нижче</span>
        </div>
        <div class="replace-separator-line"></div>
      </div>

      <!-- Replace Item Analogs -->
      <div v-if="replaceItemAnalogs != undefined" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + replaceItemAnalogs.image" :alt="replaceItemAnalogs.full_name" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="replaceItemAnalogs.on_order" class="order-badge-v2">Під замовлення</div>
            <h4 class="result-title-v2">{{ replaceItemAnalogs.full_name }}</h4>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ replaceItemAnalogs.code }}</span>
              <span class="result-status-v2"
                :class="replaceItemAnalogs.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="replaceItemAnalogs.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ replaceItemAnalogs.quantity == 0 ? 'Термін постачання до: ' +
                  replaceItemAnalogs.terms : 'В наявності' }}
              </span>
              <button v-if="replaceItemAnalogs.analogs !== undefined && replaceItemAnalogs.analogs.length > 0"
                class="btn-v2 btn-outline-v2 btn-sm-v2" @click.prevent="takeItemAnalogs(replaceItemAnalogs)">
                <i class="fa fa-copy"></i>
                Аналоги
              </button>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="replaceItemAnalogs.price > 0" class="price-info-v2">
            <span class="price-value-v2">
              {{ what == 'materials' ? (+replaceItemAnalogs.p).toFixed(2) : replaceItemAnalogs.price }}
            </span>
            <span class="price-currency-v2">{{ replaceItemAnalogs.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? replaceItemAnalogs.base_unit_name : replaceItemAnalogs.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <button class="btn-v2 btn-primary-v2" :id="'_' + replaceItemAnalogs.ref" @click="takeItem(replaceItemAnalogs)"
            :disabled="exists(replaceItemAnalogs.ref)">
            <i class="fa fa-check"></i>
            Обрати
          </button>
        </div>
      </div>

      <!-- Regular Results -->
      <div v-for="(item, index) in responseData" :key="index" class="result-item-v2">
        <div class="result-image-v2">
          <img :src="appconfig.Point + `/` + item.image" :alt="item.full_name" loading="lazy" />
        </div>

        <div class="result-content-v2">
          <div class="result-header-v2">
            <div v-if="item.on_order" class="order-badge-v2">Під замовлення</div>
            <a class="result-title-v2" target="_blank"
              :href="appconfig.Point + `/personal-office/products/` + item.slug">
              {{ item.full_name }}
            </a>
            <div class="result-meta-v2">
              <span class="result-code-v2">Код: {{ item.code }}</span>
              <span class="result-status-v2" :class="item.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="item.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ item.quantity == 0 ? 'Термін постачання до: ' + item.terms : 'В наявності' }}
              </span>
              <button v-if="item.analogs !== undefined && item.analogs.length > 0"
                class="btn-v2 btn-outline-v2 btn-sm-v2" @click="takeItemAnalogs(item)">
                <i class="fa fa-copy"></i>
                Аналоги
              </button>
            </div>
          </div>
        </div>

        <div class="result-price-v2">
          <div v-if="item.price > 0" class="price-info-v2">
            <span class="price-value-v2">{{ (+item.p).toFixed(2) }}</span>
            <span class="price-currency-v2">{{ item.cy_name }}</span>
            <span class="price-unit-v2">
              / {{ what == 'materials' ? item.base_unit_name : item.sale_unit_name }}
            </span>
          </div>
        </div>

        <div class="result-select-v2">
          <div v-if="canSelect(item)" class="select-actions-v2">
            <button class="btn-v2 btn-primary-v2" :id="'_' + item.ref" @click.prevent="takeItemProduct(item)"
              :disabled="exists(item.ref)">
              <i class="fa fa-check"></i>
              Обрати
            </button>
            <button v-if="item.recommends != undefined && item.recommends.length > 0 && what === 'materials'"
              class="btn-v2 btn-outline-v2 btn-sm-v2" :id="'_' + item.ref" @click.prevent="takeItemEdges(item)">
              <i class="fa fa-border-all"></i>
              Кромки
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="empty-state-v2">
      <div class="empty-icon-v2">
        <i class="fa fa-inbox"></i>
      </div>
      <h3 class="empty-title-v2">Даних немає</h3>
      <p class="empty-description-v2">Спробуйте змінити параметри пошуку</p>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: "search-render",
  props: ['what', 'responseData', 'materials', 'edges'],
  data() {
    return {
      appconfig: appconfig
    }
  },
  computed: {
    allowNoPrice() {
      return this.$store.state.auth.settings.allow_no_price || false;
    },
    replaceItem() {
      let item = undefined;
      let replace = this.$store.state.data.replace;
      console.log('Replace1: ' + replace);
      if (replace !== null) {
        console.log('Replace: ' + replace);
        // if (this.responseData.filter(el => el.ref === replace).length === 0 || this.responseData.length == 0) {
        const items = this.what === 'materials' ? this.materials : this.edges;
        item = items ? items.find(el => el.ref === replace) : undefined;
        // }
      }
      return item;
    },
    replaceItemAnalogs() {
      return this.replaceItem != undefined && this.replaceItem.analogs && this.replaceItem.analogs.length > 0 ? this.replaceItem : undefined;
    }
  },
  methods: {
    exists(ref) {
      const items = this.what === 'materials' ? this.materials : this.edges;
      return items && items.find(el => el.ref === ref) ? 'disabled' : false
    },
    canSelect(item) {
      // Если allow_no_price включен, показываем всегда
      if (this.allowNoPrice) {
        return true;
      }
      // Иначе показываем только если есть цена
      return item.price > 0;
    },
    takeItemProduct(item) {
      const items = this.what === 'materials' ? this.materials : this.edges;
      let elem = items && items.find(el => el.ref === item.ref);
      if (elem) return;

      let replace = this.$store.state.data.replace;
      // Замена или добавление
      if (replace != null && items) {
        let toReplaceIndex = items.findIndex(el => el.ref === replace);
        if (toReplaceIndex !== -1 && confirm('Замінити ' + items[toReplaceIndex].full_name + ' на ' + item.full_name)) {
          let current = items[toReplaceIndex];
          item = { ...item, color_show: false, color: current.color };
          this.$root.$emit('on-replace-product', this.what, item, replace);
          this.$store.commit('data/SET_REPLACE', null);
          document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
          $('#searchModal').modal('hide');
        }
      } else {
        this.$root.$emit('on-save-product', this.what, item);
        document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
      }
    },
    takeItem(item) {
      const items = this.what === 'materials' ? this.materials : this.edges;
      let elem = items && items.find(el => el.ref === item.ref);
      if (elem) return;

      let replace = this.$store.state.data.replace;
      // Замена или добавление
      if (replace != null && items) {
        let toReplaceIndex = items.findIndex(el => el.ref === replace);
        if (toReplaceIndex !== -1 && confirm('Замінити ' + items[toReplaceIndex].full_name + ' на ' + item.full_name)) {
          let current = items[toReplaceIndex];
          item = { ...item, color_show: false, color: current.color };
          this.$root.$emit('on-replace-product', this.what, item, replace);
          this.$store.commit('data/SET_REPLACE', null);
          document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
          $('#searchModal').modal('hide');
        }
      } else {
        this.$root.$emit('on-save-product', this.what, item);
        document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
      }
    },
    takeItemEdges(item) {
      this.$root.$emit('edges_change', { 'edges': item.recommends || [], 'material': item, what: this.what });
      $('#searchModal').modal('hide');
      $('#analogsModal').modal('hide');
      $('#recommendModal').modal();
    },
    takeItemAnalogs(item) {
      this.$root.$emit('analogs_change', { 'analogs': item.analogs || [], 'material': item, what: this.what });
      $('#searchModal').modal('hide');
      $('#analogsModal').modal();
    },
  }
}
</script>

<style scoped>
/* All styles moved to src/assets/scss/general/modals.scss */
</style>
